'use client';
import * as React from 'react';

import createSvgIcon from './createSvgIcon';

const Check = createSvgIcon(
  <path
    fillRule="evenodd"
    d="M21.6770991,6.30172799 L11.728328,19.4311109 C11.4910597,19.7372459 11.1372565,19.9378339 10.7464182,19.9878026 C10.3555799,20.0377714 9.96048594,19.93293 9.64991415,19.6968363 L2.54551778,14.1731386 C1.91860074,13.6852525 1.81708755,12.7955137 2.31878172,12.1858512 C2.82047589,11.5761888 3.73539605,11.4774696 4.36231309,11.9653556 L10.2865192,16.574562 L19.3370667,4.62963628 C19.6338468,4.19654618 20.151356,3.95710015 20.6841282,4.00636518 C21.2169005,4.05563022 21.6787303,4.38563495 21.8862578,4.86535798 C22.0937854,5.345081 22.0134315,5.89690043 21.6770991,6.30172799 Z"
  />,
  'Check'
);

export default Check;
